export default "<accept-invite invite-id=\"$ctrl.inviteId\"></accept-invite>\n";